import type {
  SpendingGoalWithProgress,
  WorkspaceMemberWithUser,
  LogCategory,
  LogMethod,
} from "@repo/share-log-interfaces";
import { Target } from "lucide-react";
import { EmptyState } from "@web/components/ui/empty-state";
import { SpendingGoalCard } from "./spending-goal-card";

interface SpendingGoalListProps {
  goals: SpendingGoalWithProgress[];
  onEdit: (goal: SpendingGoalWithProgress) => void;
  onDelete: (goalId: number) => void;
  onToggleActive: (goalId: number, isActive: boolean) => void;
  currentUserId: number;
  members: WorkspaceMemberWithUser[];
  categories: LogCategory[];
  methods: LogMethod[];
}

export function SpendingGoalList({
  goals,
  onEdit,
  onDelete,
  onToggleActive,
  currentUserId,
  members,
  categories,
  methods,
}: SpendingGoalListProps) {
  if (goals.length === 0) {
    return (
      <EmptyState
        icon={Target}
        title="아직 지출 목표가 없습니다"
        description="새 목표를 생성해보세요."
      />
    );
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      {goals.map((goal) => (
        <SpendingGoalCard
          key={goal.id}
          goal={goal}
          onEdit={() => onEdit(goal)}
          onDelete={() => onDelete(goal.id)}
          onToggleActive={(isActive) => onToggleActive(goal.id, isActive)}
          canManage={goal.creatorId === currentUserId || goal.userIds.length === 0 || goal.userIds.includes(currentUserId)}
          members={members}
          categories={categories}
          methods={methods}
        />
      ))}
    </div>
  );
}
